const ToS = () => import('~pages/Terms/ToS.vue')
const Privacy = () => import('~pages/Terms/Privacy.vue')

export default [
  {
    name: 'tos',
    path: '/tos',
    component: ToS,
    meta: {
      bypassToken: true
    }
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: Privacy,
    meta: {
      bypassToken: true
    }
  }
]
